module.exports = __webpack_public_path__ + "static/media/checkstand.9e662d0f.png";